module.exports = __webpack_public_path__ + "static/img/Bachelor_010737.d54c72b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010737.jpg
// module id = 237
// module chunks = 0